import React, { useState } from 'react'
import { ChevronRight, ChevronDown, ChevronLeft, X } from 'lucide-react'
import { useTranslation } from '../../hooks/useTranslation'
import { navigationData } from '../../data/navigation'

interface MobileMenuProps {
  isOpen: boolean
  onClose: () => void
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose }) => {
  const { t, isRTL } = useTranslation()
  const [openIds, setOpenIds] = useState<Record<string, boolean>>({})
  const toggle = (id: string) => setOpenIds(prev => ({ ...prev, [id]: !prev[id] }))
  
  if (!isOpen) return null

  return (
    <div className="lg:hidden">
      <div className="fixed inset-0 z-50">
        {/* خلفية التعتيم */}
        <div 
          className="fixed inset-0 bg-black/70 backdrop-blur-sm transition-opacity duration-300" 
          onClick={onClose} 
        />

        {/* القائمة الجانبية */}
        <div 
          className={`fixed top-0 h-full w-80 bg-surface border-r border-border text-text shadow-2xl transform transition-transform duration-300 ease-in-out overflow-y-auto overscroll-contain ${
            isRTL ? 'right-0 border-l border-r-0' : 'left-0'
          }`}
        >
          <div className="p-6">
            
            {/* الهيدر والعنوان */}
            <div className="flex items-center justify-between pb-4 mb-6 border-b border-border">
              <h2 className="text-base font-bold text-text tracking-wide">
                {t('navbar.mainNav.mobileMenu.toggle')}
              </h2>
              <button
                onClick={onClose}
                className="p-1 rounded-md text-text-2 hover:text-gold hover:bg-surface-soft transition-colors duration-150"
                title={t('navbar.mainNav.mobileMenu.close')}
              >
                <X size={20} />
              </button>
            </div>

            {/* شجرة الملاحة */}
            <nav className="space-y-2">
              {navigationData.map((item) => (
                <div key={item.id} className="border-b border-border/40 last:border-none pb-2">
                  <button
                    type="button"
                    onClick={() => item.hasDropdown ? toggle(item.id) : undefined}
                    className="w-full flex items-center justify-between py-2.5 px-2 text-sm font-medium rounded-md text-text hover:text-gold hover:bg-surface-soft transition-colors duration-150"
                  >
                    <span>{t(`navbar.navigation.${item.id}`)}</span>
                    {item.hasDropdown && (
                      openIds[item.id] ? (
                        <ChevronDown size={16} className="text-gold" />
                      ) : isRTL ? (
                        <ChevronLeft size={16} className="text-text-2" />
                      ) : (
                        <ChevronRight size={16} className="text-text-2" />
                      )
                    )}
                  </button>
                  
                  {/* العناصر الفرعية Dropdown */}
                  {item.hasDropdown && openIds[item.id] && (
                    <div className={`mt-1 space-y-1 py-1 ${isRTL ? 'pr-4 border-r-2 border-gold/40' : 'pl-4 border-l-2 border-gold/40'}`}>
                      {item.children?.map((child) => (
                        <a
                          key={child.id}
                          href={child.url === '/featured' ? '/catalog' : child.url}
                          className="block py-2 px-2 text-xs text-text-2 hover:text-cyan hover:bg-surface-soft rounded transition-colors duration-150"
                        >
                          {t(`navbar.dropdowns.${item.id}.${child.id}`)}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </nav>

          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileMenu